<template>
  <div>
    <TableFilters
      :filters="['product', 'supplier', 'dateRange', 'warehouse']"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      v-model="filter"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="purchaseStock"
              item-key="id"
              class="row-pointer product-list"
              id="indextable20"
            >
              <template v-slot:item.date_time="{ item }">
                <div>
                  {{ item.date_time | formatDate }}
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import axios from '@/plugins/axios';
import { mapState } from 'vuex';

export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Purchase date',
        value: 'purchase_date',
        show: true,
        disabled: false,
        width: '20%',
        align: 'center',
        render: (item) => moment(item.purchase_date).format('YYYY-MM-DD'),
      },

      {
        text: 'Supplier',
        value: 'supplier',

        show: true,
        disabled: false,
        width: '20%',
        align: 'center',
        render: (item) => item?.supplier,
      },

      {
        text: 'WareHouse',
        value: 'wareHouse',
        show: true,
        disabled: false,
        align: 'center',
        width: '20%',
        render: (item) => item?.wareHouse,
      },
      {
        text: 'Quantity',
        value: 'quantity',
        align: 'center',
        show: true,
        disabled: false,
        width: '20%',
        render: (item) => item?.quantity,
      },
    ],
    purchaseStock: [],
    hide: '',
    // Filters
    filter: {
      product: '',
      warehouse: '',
      start: '',
      end: '',
      supplier: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      if (this.filter.product) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        var filter = this.filter;

        axios
          .get(
            `reports/products/${filter.product}?warehouse=${
              filter.warehouse ? filter.warehouse : ''
            }&start=${filter.start ? filter.start : ''}&end=${
              filter.end ? filter.end : ''
            }&supplier=${filter.supplier ? filter.supplier : ''}`,
          )

          .then((res) => {
            let i = 1;
            this.purchaseStock = res.data.data;
            this.purchaseStock.map((p) => {
              p.no = i;
              i++;
            });
            setTimeout(() => {
              callBack();
              // Update Pdf To List

              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.purchaseStock);
              // Update Pdf To List_Title
              this.$store.commit('UPDATE_PDF_TITLE', 'Item Purchase Stock');
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            }, 100);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$store.commit('UPDATE_PDF_VISIBLE', false);
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

            this.messages = err.data.title;
          });
      } else {
        this.$confirm('Please Select the Product then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.purchaseStock.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.purchaseStock);

        for (let x = 0; x < Data.length; x++) {
          Data[x].purchase_date = moment(
            Data[x].purchase_date,
            'YYYY-MM-DD',
          ).format('DD/MM/YYYY');
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Item Purchase Stock', 14, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        // let height;
        // if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.warehousequery == "" ||
        //     this.filterDatas.warehousequery == null) &&
        //   (this.filterDatas.supplierquery == "" ||
        //     this.filterDatas.supplierquery == null)
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product    -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   height = 15;
        // } else if (
        //   (this.filterDatas.warehousequery == "" ||
        //     this.filterDatas.warehousequery == null) &&
        //   (this.filterDatas.supplierquery == "" ||
        //     this.filterDatas.supplierquery == null) &&
        //   (this.filterDatas.warehousequery == "" ||
        //     this.filterDatas.warehousequery == null)
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product          -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.start
        //     ? doc.text(
        //         `Date Range   -    ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   height = 20;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.warehousequery == "" ||
        //     this.filterDatas.warehousequery == null)
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product          -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier         -    ${this.filterDatas.supplierquery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   height = 20;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.supplierquery == "" ||
        //     this.filterDatas.supplierquery == null)
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product          -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.warehousequery
        //     ? doc.text(
        //         `Warehouse    -    ${this.filterDatas.warehousequery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   height = 20;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null)
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product          -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.warehousequery
        //     ? doc.text(
        //         `Warehouse    -    ${this.filterDatas.warehousequery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier         -    ${this.filterDatas.supplierquery}`,
        //         15,
        //         22
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   this.filterDatas.warehousequery == "" ||
        //   this.filterDatas.warehousequery == null
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product          -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.start
        //     ? doc.text(
        //         `Date Range   -    ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier         -    ${this.filterDatas.supplierquery}`,
        //         15,
        //         22
        //       )
        //     : null;
        //   height = 25;
        // } else {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product          -    ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.start
        //     ? doc.text(
        //         `Date Range   -    ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   this.filterDatas.warehousequery
        //     ? doc.text(
        //         `Warehouse    -    ${this.filterDatas.warehousequery}`,
        //         15,
        //         22
        //       )
        //     : null;
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier         -    ${this.filterDatas.supplierquery}`,
        //         15,
        //         27
        //       )
        //     : null;
        //   height = 30;
        // }

        const conditions = [
          { key: 'warehousequery', label: 'Warehouse' },
          { key: 'supplierquery', label: 'Supplier' },
          { key: 'productquery', label: 'Product' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-purchasestock.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable20');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-purchasestock.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    ...mapState(['filterDatas']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
